'use strict';
import $ from 'jquery';

export default class Header {
	constructor() {
		if($('header').length > 0){
			
			$(window).scroll(function(){
				var $scrollPos = $(window).scrollTop();

				if(!$('header').hasClass('shrink')){
				   $('header').addClass('shrink');
				} else if($scrollPos == 0){
					$('header').removeClass('shrink');
				}
			})
		}
	}
}